<template>
  <div class="inputHolder" v-bind:class="{entry: value != '' || focussed == true}">
    <ErranditeIcon v-bind:icon="icon"/>
    <label>{{ label }}</label>
    <input
      v-model="value"
      v-bind:type="type"
      v-on:focus="focussed = true"
      v-on:blur="focussed = false"
      v-on:keyup="changeValue"
    >
  </div>
</template>

<script>
import ErranditeIcon from "./ErranditeIcon.vue";

export default {
  name: "ErranditeLogin",
  props: {
    data: Object,
    field: String,
    type: String,
    icon: String,
    label: String
  },
  data: function() {
    return {
      value: "",
      focussed: false
    };
  },
  methods: {
    changeValue: function() {
      this.data[this.field] = this.value;
    }
  },
  components: {
    ErranditeIcon
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../styles/_variables.scss";

#errandite {

	.inputHolder {
	position: relative;
	margin-bottom: $padding/2;

	.icon {
		position: absolute;
		top: 50%;
		left: $padding/2;
		font-size: 24px;
		margin-top: -16px;
		pointer-events: none;
	}

	label {
		position: absolute;
		left: $padding;

		font-size: 16px;
		margin-left: 24px;
		top: calc(#{$padding} + 8px);
		pointer-events: none;
		transition: 0.25s;
	}

	input {
		padding: $padding * 1.35 $padding $padding * 0.65 $padding;
		padding-left: calc(#{$padding} + 24px);
	}

	input:-webkit-autofill,
	input:-webkit-autofill:hover,
	input:-webkit-autofill:focus,
	input:-webkit-autofill:active,
	input:-internal-autofill-selected {
		box-shadow: 0 0 0 30px $dark inset !important;
		-webkit-text-fill-color: $highlight;
	}

	&.entry {
		label {
		top: $padding * 0.65;
		font-size: 12px;
		}
	}
	}

}
</style>
